import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { useTracker } from '../../../hooks/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ApplyButton = ({
  actionFn,
  actionButtonObj,
  ChatSpotStyledButtonComponent,
  usageTracker,
  messageQuery
}) => {
  var _actionButtonObj$payl;
  const {
    copilotToolkitTracker
  } = useTracker(usageTracker);
  const payloadJsonStringMaybe = actionButtonObj === null || actionButtonObj === void 0 || (_actionButtonObj$payl = actionButtonObj.payload) === null || _actionButtonObj$payl === void 0 ? void 0 : _actionButtonObj$payl.payloadJson;
  if (!actionButtonObj || !payloadJsonStringMaybe) {
    return null;
  }
  let payloadJsonObj;
  try {
    payloadJsonObj = JSON.parse(payloadJsonStringMaybe);
  } catch (error) {
    consoleIfNotProd.error(`Error parsing payloadJsonString ${error}, payloadJsonStringMaybe -> ${payloadJsonStringMaybe}`);
    return null;
  }
  const handleOnClick = () => {
    var _ref, _payloadJsonObj$copil, _payloadJsonObj;
    return actionFn({
      actionType: 'apply_actions',
      infoToPassToApp: {
        toolOutput: payloadJsonObj.toolOutput,
        messageQuery
      },
      userThread: `${(_ref = (_payloadJsonObj$copil = (_payloadJsonObj = payloadJsonObj) === null || _payloadJsonObj === void 0 ? void 0 : _payloadJsonObj.copilotResponse) !== null && _payloadJsonObj$copil !== void 0 ? _payloadJsonObj$copil : actionButtonObj.text) !== null && _ref !== void 0 ? _ref : ''}`
    });
  };
  return /*#__PURE__*/_jsx(ChatSpotStyledButtonComponent, {
    "data-test-id": "copilot-plugins-workflows-generate-actions-apply-button",
    onClick: handleOnClick,
    usageTracker: copilotToolkitTracker,
    usageTrackerAppLocationKey: "copilot-plugins",
    eventName: "collaborationModeInteractions",
    use: actionButtonObj === null || actionButtonObj === void 0 ? void 0 : actionButtonObj.buttonUse,
    children: actionButtonObj === null || actionButtonObj === void 0 ? void 0 : actionButtonObj.label
  });
};
export default ApplyButton;